"use client";

import { useContext } from "react";

import { analyticsContext } from "../lib/analyticsContext";

export const useAnalyticsContext = () => useContext(analyticsContext);
